import { render, staticRenderFns } from "./BedMeshControls.vue?vue&type=template&id=0d84432e&scoped=true&"
import script from "./BedMeshControls.vue?vue&type=script&lang=ts&"
export * from "./BedMeshControls.vue?vue&type=script&lang=ts&"
import style0 from "./BedMeshControls.vue?vue&type=style&index=0&id=0d84432e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84432e",
  null
  
)

export default component.exports